'use strict';

require('../groups/CompanyGroupService.js');

function CompanyCustomerPortalsListCtrl(
  $scope, 
  $filter, 
  $state, 
  $stateParams, 
  CompanyGroupService, 
  portals, 
  formAppGroups, 
  customerPortals, 
  FormAppSubmitGroupService,
  $translate) {
  $scope.portals = portals;
  $scope.formAppGroups = formAppGroups;
  $scope.customerPortals = customerPortals;

  $scope.page = 0;
  if ($scope.portals.length === 21) {
    $scope.more = true;
    $scope.portals.pop();
  }
  $scope.groupsPage = 0;
  if ($scope.formAppGroups.length === 21) {
    $scope.moreGroups = true;
    $scope.formAppGroups.pop();
  }
  $scope.customersPage = 0;
  if ($scope.customerPortals.length === 21) {
    $scope.moreCustomers = true;
    $scope.customerPortals.pop();
  }

  $scope.masterCustomPortals = angular.copy($scope.customerPortals);
  $scope.companyId = $stateParams.companyId;

  $scope.isCustomerMyPortals = false;
  $scope.isMyPortals = false;
  $scope.isMyFormAppGroups = false;
  $scope.selectedCategory = null;
  $scope.customerSelectedCategory = null;

  $scope.tabs = [{
    'title': 'publication.portals',
    'template': 'partials/company/customer-portals/list.html',
    'icon': 'laptop'
  },
  {
    'title': 'form-app-submit-group',
    'template': 'partials/company/form-app-submit-group/list.html',
    'icon': 'mobile'
  },{
    'title': 'publication.customer-portals',
    'template': 'partials/company/customer-portals/customers-connected.html',
    'icon': 'users'
  }];

  if ($stateParams.tab && $stateParams.tab === 'form-app') {
    $scope.activeTab = 1;
  } else {
    $scope.activeTab = 0;
  }
  


  $scope.searchPortals = function(filterText, customerConnected, page) {
    $scope.page = page;
    var filter = {};
    filter.limit = 21;
    filter.offset = (page|0) * 20;
    filter.companyId = $stateParams.companyId;
    if(filterText && filterText !== ''){
      filter.q = filterText;
    }
    if(customerConnected){
      filter.customerConnected = true;
      if ($scope.customerSelectedCategory) {
        filter.categoryId = $scope.customerSelectedCategory.id;
      }
      if ($scope.isCustomerMyPortals) {
        filter.userId = $scope.currentUser.id;
      }
    }else{
      filter.customerConnected = false;
      if ($scope.selectedCategory) {
        filter.categoryId = $scope.selectedCategory.id;
      }
      if ($scope.isMyPortals) {
        filter.userId = $scope.currentUser.id;
      }
    }
    filter.type = 'VISIBLE';
    CompanyGroupService.query(filter).$promise.then(function(portals){
      if(customerConnected){
        $scope.customerPortals = portals;
        if ($scope.customerPortals.length === 21) {
          $scope.moreCustomers = true;
          $scope.customerPortals.pop();
        }else{
          $scope.moreCustomers = false;
        }
      }else{
        $scope.portals = portals;
        if ($scope.portals.length === 21) {
          $scope.more = true;
          $scope.portals.pop();
        }else{
          $scope.more = false;
        }
      }
    });
  };

  $scope.searchFormAppGroups = function(filterText, page) {
    $scope.groupsPage = page;
    var filter = {};
    filter.limit = 21;
    filter.offset = (page|0) * 20;
    filter.companyId = $stateParams.companyId;
    if ($scope.isMyFormAppGroups) {
      filter.userId = $scope.currentUser.id;
    }
    if(filterText && filterText !== ''){
      filter.q = filterText;
    }
    FormAppSubmitGroupService.query(filter).$promise.then(function(groups){
      $scope.formAppGroups = groups;
      if ($scope.formAppGroups.length === 21) {
        $scope.moreGroups = true;
        $scope.formAppGroups.pop();
      }else{
        $scope.moreGroups = false;
      }
    });
  };
}

CompanyCustomerPortalsListCtrl.resolve = {
  portals: ['$stateParams', 'CompanyGroupService', function($stateParams, CompanyGroupService) {
    var filter = {};
    filter.limit = 21;
    filter.offset = ($stateParams.page|0) * 20;
    filter.companyId = $stateParams.companyId;
    filter.customerConnected = false;
    filter.type = 'VISIBLE';
   return CompanyGroupService.query(filter).$promise;
  }],
  customerPortals: ['$stateParams', 'CompanyGroupService', function($stateParams, CompanyGroupService) {
    var filter = {};
    filter.limit = 21;
    filter.offset = ($stateParams.page|0) * 20;
    filter.companyId = $stateParams.companyId;
    filter.customerConnected = true;
    filter.type = 'VISIBLE';
    return CompanyGroupService.query(filter).$promise;
  }],
  formAppGroups: ['$stateParams', 'FormAppSubmitGroupService', function($stateParams, FormAppSubmitGroupService) {
    var filter = {};
    filter.limit = 21;
    filter.offset = ($stateParams.page|0) * 20;
    filter.companyId = $stateParams.companyId;
    return FormAppSubmitGroupService.query(filter).$promise;
  }]
};
module.exports = CompanyCustomerPortalsListCtrl;

angular.module('dokiv')
  .controller('CompanyCustomerPortalsListCtrl', [
    '$scope', 
    '$filter', 
    '$state', 
    '$stateParams', 
    'CompanyGroupService', 
    'portals',
    'formAppGroups', 
    'customerPortals', 
    'FormAppSubmitGroupService', 
    '$translate', 
    CompanyCustomerPortalsListCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/customer-portals/CompanyCustomerPortalsListCtrl.js
// module id = 330
// module chunks = 0